import { Badge, Select } from "@mantine/core";
import {
  TableActions,
  EditAction,
  DeleteAction,
  actionsColumn,
} from "../TableActions";
import { useMemo } from "react";

import { DataTable } from "../DataTable";
import defaultColors from "./utils/defaultColors";
import { useDeleteTag } from "../../api/tag";
import { useDeleteConfirm } from "../../hooks/useDeleteConfirm";
import subtypeOptions from "./utils/subtypeOptions";
import { addSpacesToCamelCase } from "./utils/addSpacesToCamelCase";

export default function TagsTable({
  data,
  isLoading,
  enableActions,
  page,
  setPage,
  sortStatus,
  setSort,
  typeFilter,
  setTypeFilter,
  subtypeFilter,
  setSubtypeFilter,
  interestTagsEnabled,
}) {
  const { mutate } = useDeleteTag();
  const confirmDelete = useDeleteConfirm("tag", mutate);

  const featureOpts = useMemo(
    () => ({ interestTagsEnabled }),
    [interestTagsEnabled]
  );
  const subtypes = useMemo(
    () => subtypeOptions(typeFilter, featureOpts),
    [typeFilter, featureOpts]
  );
  const allSubtypes = subtypeOptions(undefined, featureOpts);

  return (
    <DataTable
      records={data?.data}
      columns={[
        {
          accessor: "title",
          sortable: true,
        },
        {
          accessor: "type",
          filter: (
            <Select
              label="Filter by type"
              placeholder="All types"
              value={typeFilter}
              onChange={(value) => {
                setTypeFilter(value);
                // Clear subtype filter when type changes
                setSubtypeFilter("");
              }}
              data={[
                { value: "people", label: "People" },
                { value: "session", label: "Session" },
              ]}
              clearable
            />
          ),
          render: (tag) => <Badge variant="default">{tag.type}</Badge>,
        },
        {
          accessor: "subtype",
          filter: (
            <Select
              label="Filter by subtype"
              placeholder="All subtypes"
              value={subtypeFilter}
              onChange={(value) => setSubtypeFilter(value)}
              data={typeFilter ? subtypes : allSubtypes}
              clearable
            />
          ),
          render: (tag) => (
            <Badge
              variant="light"
              color={
                tag.color ||
                defaultColors.find((item) => item.subtype === tag.subtype).color
              }
            >
              {addSpacesToCamelCase(tag.subtype)}
            </Badge>
          ),
        },
        {
          accessor: "usageCount",
          title: "Times used",
          sortable: true,
        },
        actionsColumn((tag) => (
          <TableActions>
            <EditAction to={`${tag.id}`} />
            <DeleteAction
              onDelete={() => confirmDelete({ id: tag.id })}
              disabled={!enableActions}
            />
          </TableActions>
        )),
      ]}
      page={page}
      onPageChange={setPage}
      recordsPerPage={data?.pagination.perPage}
      totalRecords={data?.pagination.total}
      fetching={isLoading}
      sortStatus={sortStatus}
      onSortStatusChange={setSort}
    />
  );
}
